export default [
  {
    path: '/upgradePackageIndex',
    name: 'upgradePackageIndex',
    component: () => import('@/views/publicView/deviceUpgrade/apk/index'),
    meta: {
      title: '设备升级包',
      isAlive: true
    }
  },
  {
    path: '/publicView/deviceUpgrade/apk/add',
    name: 'publicView/deviceUpgrade/apk/add',
    component: () => import('@/views/publicView/deviceUpgrade/apk/add'),
    meta: {
      title: '新增APK',
      isAlive: true
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/upgradePackage.js